import { render, staticRenderFns } from "./PersonSwitcherSelectorMenu.vue?vue&type=template&id=c60cf00e"
import script from "./PersonSwitcherSelectorMenu.vue?vue&type=script&lang=js"
export * from "./PersonSwitcherSelectorMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports